import RealPlayRecordDataHelper from 'features/realplays/RealPlayRecordData.helper';

const RecordVideoHelper = ({ aiProspectOption = false }) => {
  const {
    assignment_uuid,
    roleplay,
    attitude,
    voice_id,
    customer_context,
    selectedScenario: scenario,
    session_uuid,
    videoURL,
    tempVideoUrl,
    persona_name,
    persona_image,
    setIsRecordingScenario,
  } = RealPlayRecordDataHelper();

  const convertText = (title) => (title ? title.toUpperCase().replace(/\s+/g, '_') : '');
  const convertToUpperCase = (text) => (text ? text.toUpperCase() : '');

  const body = {
    type: aiProspectOption && roleplay?.is_custom ? 'CUSTOM' : convertText(roleplay?.name),
    attitude: convertToUpperCase(attitude?.name),
    coach_name: persona_name,
    scenario: {
      uuid: scenario?.uuid,
      name: scenario?.name,
      description: scenario?.description ? scenario?.description : roleplay?.description,
    },
    customer_context,
  };

  return {
    assignment_uuid,
    scenario_uuid: scenario?.uuid,
    body,
    session_uuid,
    voice_id,
    persona_name,
    persona_image,
    setIsRecordingScenario,
    tempVideoUrl,
    videoURL,
  };
};

export default RecordVideoHelper;
